// ABOUTME: initializeModernAuth — the APP_INITIALIZER that restores the session or starts a login before the app routes.
// ABOUTME: On web without a session it holds the bootstrap until the browser leaves for Keycloak (2026-10-20 analysis).
import {Router} from '@angular/router';
import {Capacitor} from '@capacitor/core';
import {AppConfig} from '../config/app-config.model';
import {MessageService} from '../services/message.service';
import {AuthService} from './services/auth.service';
import {DeepLinkService} from './services/deep-link.service';

// Modern Auth initialization with conditional landing page
export function initializeModernAuth(
  authService: AuthService, deepLinkService: DeepLinkService, messageService: MessageService,
  router: Router, config: AppConfig
) {
  return (): Promise<unknown> => {
    // Don't redirect to login if we're on the callback URL (processing OAuth response)
    const isOnCallbackUrl = window.location.pathname.includes('/auth/callback') ||
                            window.location.search.includes('code=');

    if (isOnCallbackUrl) {
      return authService.initAuth();
    }

    return authService.initAuth().then(() => {
      // Initialize deep link listener for mobile OAuth callback
      deepLinkService.init();

      const isAuthenticated = authService.hasValidAccessToken();

      if (isAuthenticated) {
        messageService.checkUnreadMessages();
      } else {
        const isMobile = Capacitor.isNativePlatform();
        if (config.enableLandingPage || isMobile) {
          router.navigate(['/auth/landing']);
        } else {
          // Direct auth flow (web/intranet). login() only STARTS the redirect: letting the app
          // boot meanwhile let MemberIsPresentGuard call /members/me without a token and
          // replace the redirect with auth-failure.html. Keep the bootstrap pending until the
          // browser has left, and send the requested URL along so we come back to it.
          return authService.login(window.location.pathname + window.location.search)
            .then(() => new Promise<never>(() => undefined));
        }
      }
      return undefined;
    }).catch((error) => {
      console.error('[Auth] Initialization failed:', error);
      window.location.href = '/assets/auth-failure.html';
    });
  };
}
